export const UNLIMITED_QUOTA = 9999999;



// WEBPACK FOOTER //
// ./src/constants/questionQuota.js